<div class="page-container" testId="quota-template-page">
  <div class="page-shell" testId="quota-template-shell">
    <section class="page-toolbar" testId="quota-template-toolbar">
      <div class="page-heading" testId="quota-template-heading">
        <div class="heading-main" testId="quota-template-heading-main">
          <div class="heading-left">
            <button
              nz-button
              type="button"
              class="back-btn"
              [attr.aria-label]="backButtonAriaLabel"
              (click)="backToList()"
              testId="quota-template-back-button"
            >
              <i nz-icon nzType="left"></i>
            </button>
            <div class="heading-copy">
              <div class="title-row">
                <h1 class="page-title" testId="quota-template-title">{{ planTitle }}</h1>
                <nz-tag class="status-tag" [nzColor]="getStatusColor(detail?.status)" testId="quota-template-status-tag">{{
                  getStatusLabel(detail?.status)
                }}</nz-tag>
                <span class="scope-pill" testId="quota-template-scope">{{ scopeLabel }}</span>
              </div>
              <p class="page-subtitle">{{ planSubtitle }}</p>
            </div>
          </div>
          <button
            nz-button
            type="button"
            class="audit-btn"
            (click)="openAuditDrawer()"
            [disabled]="loading || !detail"
            testId="quota-template-audit-button"
          >
            <i nz-icon nzType="history"></i>
            {{ t('quota.toolbar.audit-log') }}
          </button>
        </div>
      </div>
    </section>

    <div class="form-container" testId="quota-template-form-container">
      <nz-spin [nzSpinning]="loading" testId="quota-template-spin">
        <ng-container *ngIf="detail; else emptyTpl">
          <div class="detail-page" testId="quota-template-detail">
            <section class="hero-metrics" testId="quota-template-hero-metrics">
              <article class="hero-metric hero-metric--editable" [class.is-editing]="isEditingFreeLimit">
                <div class="hero-card-head">
                  <div>
                    <span class="hero-label">{{ t('quota.table.free-quota') }}</span>
                    <strong class="hero-value">{{ formatQuotaValue(detail.freeLimitValue, detail.unit) }}</strong>
                  </div>

                  <button
                    nz-button
                    type="button"
                    class="quota-edit-btn"
                    *ngIf="!isEditingFreeLimit"
                    (click)="startEditFreeLimit()"
                    [disabled]="isSavingFreeLimit"
                    testId="quota-template-edit-free-limit-button"
                  >
                    {{ t('common.edit') }}
                  </button>
                </div>

                <div class="quota-edit-panel" *ngIf="isEditingFreeLimit">
                  <label class="quota-field">
                    <span>{{ t('quota.detail.new-free-limit') }}</span>
                    <div class="quota-input-shell" [class.has-error]="freeLimitError">
                      <input
                        type="number"
                        inputmode="numeric"
                        min="0"
                        max="999999"
                        step="1"
                        autocomplete="off"
                        [(ngModel)]="freeLimitDraft"
                        [disabled]="isSavingFreeLimit"
                        [attr.aria-invalid]="!!freeLimitError"
                        aria-describedby="free-limit-help"
                        testId="quota-template-free-limit-input"
                      />
                      <em *ngIf="detail.unit">{{ detail.unit }}</em>
                    </div>
                  </label>

                  <div class="quota-help" id="free-limit-help" *ngIf="freeLimitError">
                    {{ freeLimitError }}
                  </div>

                  <div class="quota-edit-actions">
                    <button
                      nz-button
                      type="button"
                      (click)="cancelEditFreeLimit()"
                      [disabled]="isSavingFreeLimit"
                      testId="quota-template-free-limit-cancel-button"
                      >{{ t('common.cancel') }}</button
                    >
                    <button
                      nz-button
                      nzType="primary"
                      type="button"
                      (click)="confirmSaveFreeLimit()"
                      [disabled]="isSavingFreeLimit"
                      testId="quota-template-free-limit-save-button"
                    >
                      {{ isSavingFreeLimit ? t('common.loading') : t('quota.detail.save-free-limit') }}
                    </button>
                  </div>
                </div>
              </article>
              <article class="hero-metric">
                <span class="hero-label">{{ t('quota.detail.default-value') }}</span>
                <strong class="hero-value">{{ formatQuotaValue(detail.defaultValue, detail.unit) }}</strong>
              </article>
              <article class="hero-metric">
                <span class="hero-label">{{ t('quota.table.overflow-policy') }}</span>
                <div class="hero-policy-wrap">
                  <nz-tag class="policy-tag" [nzColor]="getChargePolicyColor(detail.chargePolicyType)">
                    {{ getChargePolicyLabel(detail.chargePolicyType) }}
                  </nz-tag>
                </div>
              </article>
            </section>

            <nz-card class="detail-card">
              <div class="detail-card-toolbar">
                <div>
                  <div class="section-title">{{ t('quota.detail.project-info') }}</div>
                  <p class="section-subtitle">{{ t('quota.detail.project-info-subtitle') }}</p>
                </div>
                <button
                  nz-button
                  type="button"
                  class="status-toggle-btn"
                  [class.is-enable-action]="detail.status === 'Disabled'"
                  [class.is-disable-action]="detail.status === 'Enabled'"
                  (click)="confirmToggleItemStatus()"
                  [disabled]="isSavingStatus"
                  testId="quota-template-status-toggle-button"
                >
                  {{ isSavingStatus ? t('common.loading') : getStatusToggleLabel(detail.status) }}
                </button>
              </div>
              <nz-descriptions nzBordered [nzColumn]="2">
                <nz-descriptions-item [nzTitle]="t('quota.detail.item-name')">{{ detail.quotaName || '--' }}</nz-descriptions-item>
                <nz-descriptions-item [nzTitle]="t('quota.table.code')">{{ detail.quotaCode || '--' }}</nz-descriptions-item>
                <nz-descriptions-item [nzTitle]="t('quota.detail.plan-name')">{{ plan?.planName || '--' }}</nz-descriptions-item>
                <nz-descriptions-item [nzTitle]="t('quota.detail.scope')">{{ scopeLabel }}</nz-descriptions-item>
                <nz-descriptions-item [nzTitle]="t('quota.modal.category')">{{ detail.categoryName || '--' }}</nz-descriptions-item>
                <nz-descriptions-item [nzTitle]="t('quota.table.status')">{{ getStatusLabel(detail.status) }}</nz-descriptions-item>
                <nz-descriptions-item [nzTitle]="t('quota.table.free-quota')">{{
                  formatQuotaValue(detail.freeLimitValue, detail.unit)
                }}</nz-descriptions-item>
                <nz-descriptions-item [nzTitle]="t('quota.detail.default-value')">{{
                  formatQuotaValue(detail.defaultValue, detail.unit)
                }}</nz-descriptions-item>
                <nz-descriptions-item [nzTitle]="t('quota.detail.quota-mode')">{{
                  getQuotaModeLabel(detail.quotaMode)
                }}</nz-descriptions-item>
                <nz-descriptions-item [nzTitle]="t('quota.table.overflow-policy')">{{
                  getChargePolicyLabel(detail.chargePolicyType)
                }}</nz-descriptions-item>
                <nz-descriptions-item [nzTitle]="t('quota.table.updated-at')">{{ formatDate(detail.lastUpdateTime) }}</nz-descriptions-item>
              </nz-descriptions>
            </nz-card>

            <nz-card class="detail-card" *ngIf="detail.chargeRules?.length">
              <div class="detail-card-toolbar detail-card-toolbar--compact">
                <div class="section-title">{{ getChargePolicyLabel(detail.chargePolicyType) }}-{{ t('quota.detail.charge-rules') }}</div>
                <div class="quota-edit-actions">
                  <button
                    nz-button
                    type="button"
                    class="charge-rule-edit-btn"
                    (click)="startEditChargeRules()"
                    [disabled]="isSavingChargeRules"
                    testId="quota-template-charge-rule-edit-button"
                  >
                    {{ t('common.edit') }}
                  </button>
                </div>
              </div>
              <div class="rule-list">
                <div class="rule-item" *ngFor="let rule of detail.chargeRules; trackBy: trackByIndex">
                  <div class="rule-header">
                    <div class="rule-name">{{ rule.name || getChargePolicyLabel(rule.ruleType) }}</div>
                    <div class="rule-tag-row">
                      <nz-tag class="policy-tag" [nzColor]="getChargePolicyColor(rule.ruleType)">
                        {{ getChargePolicyLabel(rule.ruleType) }}
                      </nz-tag>
                      <nz-tag class="policy-tag recommend-tag" nzColor="gold" *ngIf="rule.recommend">{{
                        t('quota.detail.recommended')
                      }}</nz-tag>
                    </div>
                  </div>
                  <dl class="rule-definition-list rule-definition-list--view">
                    <div class="rule-definition-item rule-definition-item--summary rule-definition-item--full">
                      <dt>{{ t('quota.detail.charge-rule-description') }}</dt>
                      <dd>{{ rule.description || '--' }}</dd>
                    </div>
                    <div class="rule-definition-item rule-definition-item--metric">
                      <dt>{{ t('quota.detail.price') }}</dt>
                      <dd>{{ formatChargeRulePrice(rule) }}</dd>
                    </div>
                    <div
                      class="rule-definition-item rule-definition-item--metric rule-definition-item--full"
                      *ngIf="shouldShowEffectValue(rule)"
                    >
                      <dt>{{ t('quota.detail.retention-extension') }}</dt>
                      <dd>{{ formatChargeRuleEffectSummary(rule) }}</dd>
                    </div>
                    <div
                      class="rule-definition-item rule-definition-item--metric rule-definition-item--full"
                      *ngIf="isPointDeductRule(rule)"
                    >
                      <dt>{{ t('quota.detail.charge-rule-effective-date') }}</dt>
                      <dd>{{ rule.effectiveDate ? (rule.effectiveDate | date: 'yyyy-MM-dd') : '--' }}</dd>
                    </div>
                  </dl>
                  <div class="rule-meta">{{ t('quota.detail.updated-at') }}: {{ formatDate(rule.lastUpdateTime) }}</div>
                </div>
              </div>
            </nz-card>
          </div>
        </ng-container>
      </nz-spin>
    </div>
  </div>
</div>

<ng-template #emptyTpl>
  <div class="empty-wrap">
    <nz-empty [nzNotFoundContent]="t('quota.detail.not-found')" testId="quota-template-empty" />
  </div>
</ng-template>

<nz-modal
  class="charge-rule-modal"
  [nzVisible]="isEditingChargeRules"
  [nzFooter]="null"
  [nzWidth]="760"
  [nzClosable]="!isSavingChargeRules"
  [nzMaskClosable]="!isSavingChargeRules"
  (nzOnCancel)="cancelEditChargeRules()"
  testId="quota-template-charge-rule-modal"
>
  <ng-container *nzModalContent>
    <section class="charge-rule-modal-shell">
      <header class="charge-rule-modal-header">
        <div>
          <h2>{{ getChargePolicyLabel(detail?.chargePolicyType) }}-{{ t('quota.detail.charge-rules') }}</h2>
          <p>{{ detail?.quotaName || '--' }}</p>
        </div>
      </header>

      <div class="charge-rule-modal-list">
        <article
          class="charge-rule-modal-item"
          *ngFor="let rule of chargeRuleDrafts; let i = index; trackBy: trackByIndex"
          [testId]="'quota-template-charge-rule-modal-item-' + i"
        >
          <div class="rule-header">
            <div class="rule-name">{{ rule.name || getChargePolicyLabel(rule.ruleType) }}</div>
            <div class="rule-tag-row">
              <nz-tag class="policy-tag" [nzColor]="getChargePolicyColor(rule.ruleType)">
                {{ getChargePolicyLabel(rule.ruleType) }}
              </nz-tag>
              <nz-tag class="policy-tag recommend-tag" nzColor="gold" *ngIf="rule.recommend">{{ t('quota.detail.recommended') }}</nz-tag>
            </div>
          </div>

          <dl class="rule-definition-list">
            <div class="rule-definition-item rule-definition-item--full">
              <dt>{{ t('quota.detail.charge-rule-description') }}</dt>
              <dd>{{ rule.description || '--' }}</dd>
            </div>
          </dl>

          <div class="rule-edit-grid rule-edit-grid--focus">
            <div class="rule-inline-price">
              <input
                type="text"
                [(ngModel)]="rule.unitPrice"
                maxlength="20"
                [attr.aria-label]="t('quota.detail.charge-rule-price')"
                [testId]="'quota-template-charge-rule-price-input-' + i"
              />
              <span class="rule-inline-token">{{ rule.currency || '--' }} / {{ rule.billingUnit || '--' }}</span>
            </div>

            <div class="rule-inline-effect" *ngIf="shouldShowEffectValue(rule)">
              {{ t('quota.detail.retention-extension') }}: {{ formatChargeRuleEffectSummary(rule) }}
            </div>
          </div>

          <div class="rule-date-row" *ngIf="isPointDeductRule(rule)">
            <label class="rule-field rule-field--editable">
              <span>{{ t('quota.detail.charge-rule-effective-date') }}</span>
              <input
                type="date"
                [ngModel]="getChargeRuleEffectiveDateInputValue(rule)"
                (ngModelChange)="updateChargeRuleEffectiveDate(rule, $event)"
                [testId]="'quota-template-charge-rule-date-input-' + i"
              />
            </label>
          </div>
        </article>
      </div>

      <footer class="charge-rule-modal-footer">
        <button
          nz-button
          type="button"
          (click)="cancelEditChargeRules()"
          [disabled]="isSavingChargeRules"
          testId="quota-template-charge-rule-cancel-button"
          >{{ t('common.cancel') }}</button
        >
        <button
          nz-button
          nzType="primary"
          type="button"
          (click)="saveChargeRules()"
          [disabled]="isSavingChargeRules"
          testId="quota-template-charge-rule-save-button"
        >
          {{ isSavingChargeRules ? t('common.loading') : t('common.save') }}
        </button>
      </footer>
    </section>
  </ng-container>
</nz-modal>

<nz-drawer
  [nzVisible]="auditDrawerVisible"
  [nzClosable]="true"
  [nzMaskClosable]="true"
  [nzWidth]="520"
  nzPlacement="right"
  nzTitle=" "
  (nzOnClose)="closeAuditDrawer()"
  testId="quota-template-audit-drawer"
>
  <ng-container *nzDrawerContent>
    <section class="audit-drawer-shell">
      <header class="audit-drawer-header">
        <div>
          <span class="audit-drawer-eyebrow">{{ t('quota.detail.audit.record') }}</span>
          <h2>{{ detail?.quotaName || t('quota.detail.audit.item-title') }}</h2>
          <p>{{ t('quota.detail.audit.subtitle') }}</p>
        </div>
      </header>

      <nz-spin [nzSpinning]="auditDrawerLoading" testId="quota-template-audit-spin">
        <ng-container *ngIf="auditLogs.length; else auditEmptyTpl">
          <div class="audit-log-list">
            <article
              class="audit-log-card"
              *ngFor="let log of auditLogs; let i = index; trackBy: trackByAuditLog"
              [testId]="'quota-template-audit-log-card-' + i"
            >
              <span class="audit-log-marker" aria-hidden="true"></span>
              <div class="audit-log-head">
                <div class="audit-log-title-block">
                  <div class="audit-log-title">{{ log.fieldName || log.fieldCode || t('quota.detail.audit.field-change') }}</div>
                  <div class="audit-log-meta">
                    <span>{{ log.createTime ? (log.createTime | date: 'yyyy-MM-dd HH:mm:ss') : '--' }}</span>
                  </div>
                </div>
                <nz-tag class="status-tag" nzColor="blue">{{ log.quotaName || log.quotaCode || t('quota.detail.audit.item-tag') }}</nz-tag>
              </div>

              <div class="audit-log-diff" *ngIf="getAuditDiffRows(log) as rows">
                <div class="audit-diff-head" *ngIf="rows.length">
                  <span>{{ t('quota.detail.audit.field-change') }}</span>
                  <span>{{ t('quota.detail.audit.old-value') }}</span>
                  <span>{{ t('quota.detail.audit.new-value') }}</span>
                </div>
                <div class="audit-diff-row" *ngFor="let row of rows; trackBy: trackByAuditDiff">
                  <div class="audit-diff-field">{{ row.label }}</div>
                  <div class="audit-value-box">{{ row.oldValue }}</div>
                  <div class="audit-value-box is-new">{{ row.newValue }}</div>
                </div>
              </div>

              <div class="audit-log-foot">
                <span>{{ t('quota.detail.audit.operator') }}{{ log.operatorName || log.operatorId || '--' }}</span>
              </div>
            </article>
          </div>

          <div class="audit-pagination">
            <nz-pagination
              [nzPageIndex]="auditPageIndex + 1"
              [nzTotal]="auditTotalCount"
              [nzPageSize]="auditPageSize"
              [nzShowSizeChanger]="true"
              [nzPageSizeOptions]="[10, 20, 50]"
              [nzSimple]="true"
              (nzPageIndexChange)="onAuditPageChange($event)"
              (nzPageSizeChange)="onAuditPageSizeChange($event)"
              testId="quota-template-audit-pagination"
            />
          </div>
        </ng-container>
      </nz-spin>
    </section>
  </ng-container>
</nz-drawer>

<ng-template #auditEmptyTpl>
  <div class="audit-empty-wrap">
    <nz-empty [nzNotFoundContent]="t('quota.detail.audit.empty')" testId="quota-template-audit-empty" />
  </div>
</ng-template>
